<template>
	<div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
		style="overflow: hidden;">
		<div class="m-portlet m-portlet--mobile">
			<PageHead label='住培生月度绩效考评' label2="评分详细" url="/achievement/stu/scorerecordchecklist"></PageHead>
			<el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form"
				ref="form">
				<div class="m-portlet__body" style="padding: .2rem 2.2rem;">
					<div style="width: 100%;height: 40px;line-height: 40px;text-align: center;font-size: 18px;">
						<span style="text-decoration: underline;">{{ this.secname }}</span><span
							style="text-decoration: underline;padding-left: 10px;">{{ this.cpidate | formatDate }}</span>月（全科）医师规范化培训学员考核汇总表
					</div>
					<div style="width: 100%;overflow: auto;">
						<el-table ref="scoretable" v-if="ScoreType == '0' || ScoreType == '3'" :data="form.tableData"
							height="500" stripe border
							:header-cell-style="{ 'color': '#000000', 'background': '#F7F8FA', 'text-align': 'center', 'height': '200px' }">
							<el-table-column fixed :label="this.form.cpidate" width="150">
								<template slot-scope="scope">
									<span>{{ scope.row.CPIDName }}({{ scope.row.CPIDNo }})</span>
									<br><span>{{ scope.row.CPIDSecName }}</span>
									<span v-if="scope.row.Delay == 1" style="color: green;">(延期考评)</span>
									<span v-else-if="scope.row.ScoreType != 4">(出科月)</span>
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									有无<br>形成性<br>评价
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent1" @change="SelectChange(scope.row, 1, '')"
										v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="有" value="有"></el-option>
										<el-option label="无" value="无"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore1 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									理论<br>月考<br>成绩
								</template>
								<template slot-scope="scope">
									<el-input v-model="scope.row.CPIDContent2" @blur="InputBlur(scope.row, 2)"
										v-show="scope.row.Delay != 1">
									</el-input>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore2 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									技能<br>考核<br>成绩
								</template>
								<template slot-scope="scope">
									<el-input v-model="scope.row.CPIDContent3" @blur="InputBlur(scope.row, 3)"
										v-show="scope.row.Delay != 1"
										:disabled="scope.row.ScoreEditStatus == 0 ? true : false"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore3 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									参加<br>小讲<br>课次<br>数
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent4" @change="SelectChange(scope.row, 4, '')"
										v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="0" value="0"></el-option>
										<el-option label="1" value="1"></el-option>
										<el-option label="2" value="2"></el-option>
										<el-option label="3" value="3"></el-option>
										<el-option label="≥4" value="≥4"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore4 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									参加<br>教学<br>查房<br>次数
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent5" @change="SelectChange(scope.row, 5, '')"
										v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="0" value="0"></el-option>
										<el-option label="1" value="1"></el-option>
										<el-option label="2" value="2"></el-option>
										<el-option label="3" value="3"></el-option>
										<el-option label="≥4" value="≥4"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore5 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									参加<br>疑难<br>病例<br>讨论<br>次数
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent6" @change="SelectChange(scope.row, 6, '')"
										v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="0" value="0"></el-option>
										<el-option label="1" value="1"></el-option>
										<el-option label="2" value="2"></el-option>
										<el-option label="3" value="3"></el-option>
										<el-option label="≥4" value="≥4"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore6 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									手写<br>大病<br>历份<br>数
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent7" @change="SelectChange(scope.row, 7, '')"
										v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="0" value="0"></el-option>
										<el-option label="1" value="1"></el-option>
										<el-option label="2" value="2"></el-option>
										<el-option label="3" value="3"></el-option>
										<el-option label="≥4" value="≥4"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore7 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									手写<br>大病<br>历质<br>量
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent8" v-show="scope.row.Delay != 1"
										@change="SelectChange(scope.row, 8, '手写大病历质量')">
										<el-option label="请选择" value=""></el-option>
										<el-option label="优秀" value="优秀"></el-option>
										<el-option label="良好" value="良好"></el-option>
										<el-option label="一般" value="一般"></el-option>
										<el-option label="较差" value="较差"></el-option>
										<el-option label="无" value="无"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore8 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									读书<br>心得<br>质量
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent9" v-show="scope.row.Delay != 1"
										@change="SelectChange(scope.row, 9, '读书心得质量')">
										<el-option label="请选择" value=""></el-option>
										<el-option label="优秀" value="优秀"></el-option>
										<el-option label="良好" value="良好"></el-option>
										<el-option label="一般" value="一般"></el-option>
										<el-option label="较差" value="较差"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore9 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									APP<br>填写<br>是否<br>完成
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent10" v-show="scope.row.Delay != 1"
										@change="SelectChange(scope.row, 10, '')">
										<el-option label="请选择" value=""></el-option>
										<el-option label="是" value="是"></el-option>
										<el-option label="否" value="否"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore10 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									各级<br>反馈<br>意见
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent11" v-show="scope.row.Delay != 1"
										@change="SelectChange(scope.row, 11, '各级反馈意见')">
										<el-option label="请选择" value=""></el-option>
										<el-option label="优秀" value="优秀"></el-option>
										<el-option label="良好" value="良好"></el-option>
										<el-option label="一般" value="一般"></el-option>
										<el-option label="较差" value="较差"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="160">
								<template slot-scope="scope">
									<!-- 		{{scope.row.CPIDScore11}} -->
									<el-input-number v-model="scope.row.CPIDScore11" style="width: 130px;" :min="0"
										:max="20"></el-input-number>
								</template>
							</el-table-column>
							<el-table-column label="总分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore = scope.row.CPIDScore1 * 1 + scope.row.CPIDScore2 * 1 +
										scope.row.CPIDScore3 * 1 + scope.row.CPIDScore4 * 1 + scope.row.CPIDScore5 * 1 +
										scope.row.CPIDScore6 * 1 + scope.row.CPIDScore7 * 1 + scope.row.CPIDScore8 * 1 +
										scope.row.CPIDScore9 * 1 + scope.row.CPIDScore10 * 1 + scope.row.CPIDScore11 * 1 }}
								</template>
							</el-table-column>
						</el-table>
						<el-table ref="scoretable" v-if="ScoreType == '1'" :data="form.tableData" height="500" stripe
							border
							:header-cell-style="{ 'color': '#000000', 'background': '#F7F8FA', 'text-align': 'center', 'height': '200px' }">
							<el-table-column :label="this.form.cpidate" width="150" fixed>
								<template slot-scope="scope">
									<span>{{ scope.row.CPIDName }}({{ scope.row.CPIDNo }})</span>
									<br><span>{{ scope.row.CPIDSecName }}</span>
									<span v-if="scope.row.Delay == 1" style="color: green;">(延期考评)</span>
									<span v-else-if="scope.row.ScoreType != 4">(出科月)</span>
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									有无<br>形成性<br>评价
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent1" @change="SelectChange1(scope.row, 1, '')"
										v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="有" value="有"></el-option>
										<el-option label="无" value="无"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore1 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									理论<br>月考<br>成绩
								</template>
								<template slot-scope="scope">
									<el-input v-model="scope.row.CPIDContent2" @blur="InputBlur1(scope.row, 2)"
										v-show="scope.row.Delay != 1">
									</el-input>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore2 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									技能<br>考核<br>成绩
								</template>
								<template slot-scope="scope">
									<el-input v-model="scope.row.CPIDContent3" @blur="InputBlur1(scope.row, 3)"
										v-show="scope.row.Delay != 1"
										:disabled="scope.row.ScoreEditStatus == 0 ? true : false"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore3 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									参加<br>小讲<br>课次<br>数
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent4" @change="SelectChange1(scope.row, 4, '')"
										v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="0" value="0"></el-option>
										<el-option label="1" value="1"></el-option>
										<el-option label="2" value="2"></el-option>
										<el-option label="3" value="3"></el-option>
										<el-option label="≥4" value="≥4"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore4 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									参加<br>教学<br>查房<br>次数
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent5" @change="SelectChange1(scope.row, 5, '')"
										v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="0" value="0"></el-option>
										<el-option label="1" value="1"></el-option>
										<el-option label="2" value="2"></el-option>
										<el-option label="3" value="3"></el-option>
										<el-option label="≥4" value="≥4"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore5 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									参加<br>疑难<br>病例<br>讨论<br>次数
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent6" @change="SelectChange1(scope.row, 6, '')"
										v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="0" value="0"></el-option>
										<el-option label="1" value="1"></el-option>
										<el-option label="2" value="2"></el-option>
										<el-option label="3" value="3"></el-option>
										<el-option label="≥4" value="≥4"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore6 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									麻醉<br>前访<br>视及<br>计划<br>完成<br>情况
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent7"
										@change="SelectChange1(scope.row, 7, '麻醉前访视及计划完成情况')" v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="优秀" value="优秀"></el-option>
										<el-option label="良好" value="良好"></el-option>
										<el-option label="一般" value="一般"></el-option>
										<el-option label="较差" value="较差"></el-option>
										<el-option label="无" value="无"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore7 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									读书<br>心得<br>质量
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent8" v-show="scope.row.Delay != 1"
										@change="SelectChange1(scope.row, 8, '读书心得质量')">
										<el-option label="请选择" value=""></el-option>
										<el-option label="优秀" value="优秀"></el-option>
										<el-option label="良好" value="良好"></el-option>
										<el-option label="一般" value="一般"></el-option>
										<el-option label="较差" value="较差"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore8 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									APP<br>填写<br>是否<br>完成
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent9" @change="SelectChange1(scope.row, 9, '')"
										v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="是" value="是"></el-option>
										<el-option label="否" value="否"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore9 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									各级<br>反馈<br>意见
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent10" v-show="scope.row.Delay != 1"
										@change="SelectChange1(scope.row, 10, '各级反馈意见')">
										<el-option label="请选择" value=""></el-option>
										<el-option label="优秀" value="优秀"></el-option>
										<el-option label="良好" value="良好"></el-option>
										<el-option label="一般" value="一般"></el-option>
										<el-option label="较差" value="较差"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="160">
								<template slot-scope="scope">
									<!-- {{scope.row.CPIDScore10}} -->
									<el-input-number v-model="scope.row.CPIDScore10" style="width: 130px;" :min="0"
										:max="20"></el-input-number>
								</template>
							</el-table-column>
							<el-table-column label="总分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore = scope.row.CPIDScore1 * 1 + scope.row.CPIDScore2 * 1 +
										scope.row.CPIDScore3 * 1 + scope.row.CPIDScore4 * 1 + scope.row.CPIDScore5 * 1 +
										scope.row.CPIDScore6 * 1 + scope.row.CPIDScore7 * 1 + scope.row.CPIDScore8 * 1 +
										scope.row.CPIDScore9 * 1 + scope.row.CPIDScore10 * 1 }}
								</template>
							</el-table-column>
						</el-table>
						<el-table ref="scoretable" v-if="ScoreType == '2'" :data="form.tableData" height="500" stripe
							border
							:header-cell-style="{ 'color': '#000000', 'background': '#F7F8FA', 'text-align': 'center', 'height': '200px' }">
							<el-table-column fixed :label="this.form.cpidate" width="150">
								<template slot-scope="scope">
									<span>{{ scope.row.CPIDName }}({{ scope.row.CPIDNo }})</span>
									<br><span>{{ scope.row.CPIDSecName }}</span>
									<span v-if="scope.row.Delay == 1" style="color: green;">(延期考评)</span>
									<span v-else-if="scope.row.ScoreType != 4">(出科月)</span>
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									有无<br>形成性<br>评价
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent1" @change="SelectChange1(scope.row, 1, '')"
										v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="有" value="有"></el-option>
										<el-option label="无" value="无"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore1 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									理论<br>月考<br>成绩
								</template>
								<template slot-scope="scope">
									<el-input v-model="scope.row.CPIDContent2" @blur="InputBlur1(scope.row, 2)"
										v-show="scope.row.Delay != 1">
									</el-input>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore2 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									技能<br>考核<br>成绩
								</template>
								<template slot-scope="scope">
									<el-input v-model="scope.row.CPIDContent3" @blur="InputBlur(scope.row, 3)"
										v-show="scope.row.Delay != 1"
										:disabled="scope.row.ScoreEditStatus == 0 ? true : false"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore3 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									参加<br>小讲<br>课次<br>数
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent4" @change="SelectChange1(scope.row, 4, '')"
										v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="0" value="0"></el-option>
										<el-option label="1" value="1"></el-option>
										<el-option label="2" value="2"></el-option>
										<el-option label="3" value="3"></el-option>
										<el-option label="≥4" value="≥4"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore4 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									参加<br>教学<br>查房<br>次数
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent5" @change="SelectChange1(scope.row, 5, '')"
										v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="0" value="0"></el-option>
										<el-option label="1" value="1"></el-option>
										<el-option label="2" value="2"></el-option>
										<el-option label="3" value="3"></el-option>
										<el-option label="≥4" value="≥4"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore5 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									参加<br>疑难<br>病例<br>讨论<br>次数
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent6" @change="SelectChange1(scope.row, 6, '')"
										v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="0" value="0"></el-option>
										<el-option label="1" value="1"></el-option>
										<el-option label="2" value="2"></el-option>
										<el-option label="3" value="3"></el-option>
										<el-option label="≥4" value="≥4"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore6 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									专业<br>报告<br>判读<br>水平
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent7" v-show="scope.row.Delay != 1"
										@change="SelectChange1(scope.row, 7, '专业报告判读水平')">
										<el-option label="请选择" value=""></el-option>
										<el-option label="优秀" value="优秀"></el-option>
										<el-option label="良好" value="良好"></el-option>
										<el-option label="一般" value="一般"></el-option>
										<el-option label="较差" value="较差"></el-option>
										<el-option label="无" value="无"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore7 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									读书<br>心得<br>质量
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent8" v-show="scope.row.Delay != 1"
										@change="SelectChange1(scope.row, 8, '读书心得质量')">
										<el-option label="请选择" value=""></el-option>
										<el-option label="优秀" value="优秀"></el-option>
										<el-option label="良好" value="良好"></el-option>
										<el-option label="一般" value="一般"></el-option>
										<el-option label="较差" value="较差"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore8 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									APP<br>填写<br>是否<br>完成
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent9" @change="SelectChange1(scope.row, 9, '')"
										v-show="scope.row.Delay != 1">
										<el-option label="请选择" value=""></el-option>
										<el-option label="是" value="是"></el-option>
										<el-option label="否" value="否"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore9 }}
								</template>
							</el-table-column>
							<el-table-column width="150">
								<template slot="header">
									各级<br>反馈<br>意见
								</template>
								<template slot-scope="scope">
									<el-select v-model="scope.row.CPIDContent10" v-show="scope.row.Delay != 1"
										@change="SelectChange1(scope.row, 10, '各级反馈意见')">
										<el-option label="请选择" value=""></el-option>
										<el-option label="优秀" value="优秀"></el-option>
										<el-option label="良好" value="良好"></el-option>
										<el-option label="一般" value="一般"></el-option>
										<el-option label="较差" value="较差"></el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="得分" width="160">
								<template slot-scope="scope">
									<!-- {{scope.row.CPIDScore10}} -->
									<el-input-number v-model="scope.row.CPIDScore10" style="width: 130px;" :min="0"
										:max="20"></el-input-number>
								</template>
							</el-table-column>
							<el-table-column label="总分" width="100">
								<template slot-scope="scope">
									{{ scope.row.CPIDScore = scope.row.CPIDScore1 * 1 + scope.row.CPIDScore2 * 1 +
										scope.row.CPIDScore3 * 1 + scope.row.CPIDScore4 * 1 + scope.row.CPIDScore5 * 1 +
										scope.row.CPIDScore6 * 1 + scope.row.CPIDScore7 * 1 + scope.row.CPIDScore8 * 1 +
										scope.row.CPIDScore9 * 1 + scope.row.CPIDScore10 * 1 }}
								</template>
							</el-table-column>
						</el-table>
						<div style="margin: 15px;">
							<div style="font-size: 18px;">优秀评分理由填写</div>
							<el-table :data="form.remarkTable">
								<el-table-column prop="StuName" label="学员" width="150">
								</el-table-column>
								<el-table-column prop="StuNo" label="工号" width="150">
								</el-table-column>
								<el-table-column prop="ETDContent" label="评分项" width="200">
								</el-table-column>
								<el-table-column label="理由">
									<template slot-scope="scope">
										<el-input v-model="scope.row.ContentRemark"></el-input>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-xl-2 col-form-label" style="padding-top: 20px;">修改意见：</label>
						<div class="col-xl-10">
							<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容"
								v-model="form.editinfo">
							</el-input>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-xl-2 col-form-label">签字凭证：</label>
						<div class="col-xl-10">
							<el-table :data="tableFileData" stripe style="width: 100%" size="medium"
								v-if="tableFileData.length != 0">
								<el-table-column label="附件名">
									<template slot-scope="scope">
										{{ scope.row.FileName }}<span
											style="color: #409EFF;cursor: pointer;padding-left: 10px;"
											@click="See(scope.row)">[查看]</span>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<div class="form-group m-form__group row">
						<label class="col-xl-2 col-form-label" style="padding-top: 20px;">审核意见：</label>
						<div class="col-xl-10">
							<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容"
								v-model="form.cpicinfo">
							</el-input>
						</div>
					</div>
				</div>
				<div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
					<div class="m-form__actions m-form__actions--solid">
						<div class="row">
							<div class="col-lg-12 m--align-center">
								<el-button type="success" icon="el-icon-check" @click="Check(1)"
									v-loading.fullscreen.lock="fullscreenLoading">通过</el-button>
								<el-button type="danger" icon="el-icon-refresh" @click="Check(2)"
									v-loading.fullscreen.lock="fullscreenLoading">退回</el-button>
							</div>
						</div>
					</div>
				</div>
			</el-form>
		</div>
		<el-dialog title="凭证查看" :visible.sync="dialogImgVisible">
			<el-image style="width: 100%;" :src="imgurl"></el-image>
		</el-dialog>
		<el-dialog width="30%" title="异常数据提醒" :visible.sync="errorInfoVisible">
			<el-table :data="errorTableData" stripe style="width: 100%" size="medium">
				<el-table-column label="姓名">
					<template slot-scope="scope">
						{{ scope.row.CPIDName }}
					</template>
				</el-table-column>
				<el-table-column label="原因">
					<template slot-scope="scope">
						{{ scope.row.ErrorInfo }}
					</template>
				</el-table-column>

			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button type="success" @click="errorInfoVisible = false"
					v-loading.fullscreen.lock="fullscreenLoading">关闭
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'StuScoreRecordCheck',
	data() {
		return {
			form: {
				token: '',
				id: '',
				cpicinfo: '',
				cpicstatus: '',
				editinfo: '',
				cpitype: '1',
				tableData: [],
				remarkTable: []
			},
			condition: {
				token: '',
				id: ''
			},
			content: [{
				value: '有无入科报到'
			}, {
				value: '理论月考成绩'
			}, {
				value: '技能考核成绩'
			}, {
				value: '参加小讲座次数'
			}, {
				value: '参加教学查房次数'
			}, {
				value: '参加疑难病例讨论次数'
			}, {
				value: '手写大病历份数'
			}, {
				value: '手写大病历质量'
			}, {
				value: '读书心得质量'
			}, {
				value: 'APP填写完成率'
			}, {
				value: '各级反馈意见'
			}],
			content1: [{
				value: '有无入科报到'
			}, {
				value: '理论月考成绩'
			}, {
				value: '技能考核成绩'
			}, {
				value: '参加小讲座次数'
			}, {
				value: '参加教学查房次数'
			}, {
				value: '参加疑难病例讨论次数'
			}, {
				value: '专业报告判读水平'
			}, {
				value: '读书心得质量'
			}, {
				value: 'APP填写完成率'
			}, {
				value: '各级反馈意见'
			}],
			content2: [{
				value: '有无入科报到'
			}, {
				value: '理论月考成绩'
			}, {
				value: '技能考核成绩'
			}, {
				value: '参加小讲座次数'
			}, {
				value: '参加教学查房次数'
			}, {
				value: '参加疑难病例讨论次数'
			}, {
				value: '麻醉前访视及计划完成情况'
			}, {
				value: '读书心得质量'
			}, {
				value: 'APP填写完成率'
			}, {
				value: '各级反馈意见'
			}],
			cpifile: '',
			cpifiledesc: '',
			cpicstatusname: '',
			fullscreenLoading: false,
			secname: '',
			cpidate: '',
			tableFileData: [],
			FileGuid: '',
			dialogImgVisible: false,
			imgurl: '',
			ScoreType: '0',
			CheckError: 0,
			CheckErrorMessage: '',
			//提示异常数据变量
			errorInfoVisible: false,
			errorTableData: [],
		}
	},
	filters: {
		formatDate(val) {
			var now = new Date(val)
			var y = now.getFullYear()
			var m = now.getMonth() + 1
			return y + '-' + (m < 10 ? '0' + m : m)
		}
	},
	methods: {
		SelectChange: function (row, index, title) {
			if (index == 1) {
				if (row.CPIDContent1 == "有") {
					row.CPIDScore1 = 5
				} else if (row.CPIDContent1 == "无") {
					row.CPIDScore1 = 0
				} else {
					row.CPIDScore1 = 0
				}
			} else if (index == 4) {
				if (row.CPIDContent4 == "0") {
					row.CPIDScore4 = 0
				} else if (row.CPIDContent4 == "1") {
					row.CPIDScore4 = 2.5
				} else if (row.CPIDContent4 == "2") {
					row.CPIDScore4 = 5
				} else if (row.CPIDContent4 == "3") {
					row.CPIDScore4 = 5
				} else if (row.CPIDContent4 == "≥4") {
					row.CPIDScore4 = 5
				} else {
					row.CPIDScore4 = 0
				}
			} else if (index == 5) {
				if (row.CPIDContent5 == "0") {
					row.CPIDScore5 = 0
				} else if (row.CPIDContent5 == "1") {
					row.CPIDScore5 = 5
				} else if (row.CPIDContent5 == "2") {
					row.CPIDScore5 = 10
				} else if (row.CPIDContent5 == "3") {
					row.CPIDScore5 = 10
				} else if (row.CPIDContent5 == "≥4") {
					row.CPIDScore5 = 10
				} else {
					row.CPIDScore5 = 0
				}
			} else if (index == 6) {
				if (row.CPIDContent6 == "0") {
					row.CPIDScore6 = 0
				} else if (row.CPIDContent6 == "1") {
					row.CPIDScore6 = 2.5
				} else if (row.CPIDContent6 == "2") {
					row.CPIDScore6 = 5
				} else if (row.CPIDContent6 == "3") {
					row.CPIDScore6 = 5
				} else if (row.CPIDContent6 == "≥4") {
					row.CPIDScore6 = 5
				} else {
					row.CPIDScore6 = 0
				}
			} else if (index == 7) {
				if (row.CPIDContent7 == "0") {
					row.CPIDScore7 = 0
					row.CPIDContent8 = "无"
					row.CPIDScore8 = 0
				} else if (row.CPIDContent7 == "1") {
					row.CPIDScore7 = 2.5
				} else if (row.CPIDContent7 == "2") {
					row.CPIDScore7 = 5
				} else if (row.CPIDContent7 == "3") {
					row.CPIDScore7 = 5
				} else if (row.CPIDContent7 == "≥4") {
					row.CPIDScore7 = 5
				} else {
					row.CPIDScore7 = 0
					row.CPIDContent8 = ""
					row.CPIDScore8 = 0
				}
			} else if (index == 8) {
				if (row.CPIDContent8 == "优秀") {
					row.CPIDScore8 = 10
				} else if (row.CPIDContent8 == "良好") {
					row.CPIDScore8 = 10
				} else if (row.CPIDContent8 == "一般") {
					row.CPIDScore8 = 5
				} else if (row.CPIDContent8 == "较差") {
					row.CPIDScore8 = 0
				} else if (row.CPIDContent8 == "无") {
					row.CPIDScore8 = 0
				} else {
					row.CPIDScore8 = 0
				}

				if (row.CPIDContent8 == "优秀") {
					let arg = {
						CPIID: '',
						StuID: row.CPIDPersonID,
						StuName: row.CPIDName,
						StuNo: row.CPIDNo,
						ETDContent: title,
						ContentRemark: ''
					}

					this.form.remarkTable.push(arg)
				} else {
					let objs = this.form.remarkTable
					let newobj = objs.reduce((total, current) => {
						if (current.StuID != row.CPIDPersonID) {
							total.push(current)
						} else {
							if (current.ETDContent != title) {
								total.push(current)
							}
						}
						return total
					}, []);

					this.form.remarkTable = newobj
				}

			} else if (index == 9) {
				if (row.CPIDContent9 == "优秀") {
					row.CPIDScore9 = 10
				} else if (row.CPIDContent9 == "良好") {
					row.CPIDScore9 = 10
				} else if (row.CPIDContent9 == "一般") {
					row.CPIDScore9 = 5
				} else if (row.CPIDContent9 == "较差") {
					row.CPIDScore9 = 0
				} else {
					row.CPIDScore9 = 0
				}

				if (row.CPIDContent9 == "优秀") {
					let arg = {
						StuID: row.CPIDPersonID,
						StuName: row.CPIDName,
						StuNo: row.CPIDNo,
						ETDContent: title,
						ContentRemark: ''
					}

					this.form.remarkTable.push(arg)
				} else {
					let objs = this.form.remarkTable
					let newobj = objs.reduce((total, current) => {
						if (current.StuID != row.CPIDPersonID) {
							total.push(current)
						} else {
							if (current.ETDContent != title) {
								total.push(current)
							}
						}
						return total
					}, []);

					this.form.remarkTable = newobj
				}
			} else if (index == 10) {
				if (row.CPIDContent10 == "是") {
					row.CPIDScore10 = 10
				} else if (row.CPIDContent8 == "否") {
					row.CPIDScore10 = 0
				} else {
					row.CPIDScore10 = 0
				}
			} else {
				if (row.CPIDContent11 == "优秀") {
					row.CPIDScore11 = 20
				} else if (row.CPIDContent11 == "良好") {
					row.CPIDScore11 = 20
				} else if (row.CPIDContent11 == "一般") {
					row.CPIDScore11 = 10
				} else if (row.CPIDContent11 == "较差") {
					row.CPIDScore11 = 0
				} else {
					row.CPIDScore11 = 0
				}

				if (row.CPIDContent11 == "优秀") {
					let arg = {
						StuID: row.CPIDPersonID,
						StuName: row.CPIDName,
						StuNo: row.CPIDNo,
						ETDContent: title,
						ContentRemark: ''
					}

					this.form.remarkTable.push(arg)
				} else {
					let objs = this.form.remarkTable
					let newobj = objs.reduce((total, current) => {
						if (current.StuID != row.CPIDPersonID) {
							total.push(current)
						} else {
							if (current.ETDContent != title) {
								total.push(current)
							}
						}
						return total
					}, []);

					this.form.remarkTable = newobj
				}
			}
		},
		InputBlur: function (row, index) {
			if (index == 2) {
				if (parseFloat(row.CPIDContent2).toString() == "NaN") {
					row.CPIDContent2 = ''
					row.CPIDScore2 = 0
				} else {
					if (row.CPIDContent2 >= 80) {
						if (row.CPIDContent2 > 100) {
							row.CPIDContent2 = 100
						}
						row.CPIDScore2 = 10
					} else if (row.CPIDContent2 >= 70 && row.CPIDContent2 < 80) {
						row.CPIDScore2 = 5
					} else {
						if (row.CPIDContent2 < 0) {
							row.CPIDContent2 = 0
						}
						row.CPIDScore2 = 0
					}
					return true
				}
			} else if (index == 3) {
				if (parseFloat(row.CPIDContent3).toString() == "NaN") {
					row.CPIDContent3 = ''
					row.CPIDScore3 = 0
				} else {
					if (row.CPIDContent3 >= 80) {
						if (row.CPIDContent3 > 100) {
							row.CPIDContent3 = 100
						}
						row.CPIDScore3 = 10
					} else if (row.CPIDContent3 >= 70 && row.CPIDContent3 < 80) {
						row.CPIDScore3 = 5
					} else {
						if (row.CPIDContent3 < 0) {
							row.CPIDContent3 = 0
						}
						row.CPIDScore3 = 0
					}
					return true
				}
			}
		},
		See: function (row) {
			this.imgurl = this.$utils.Url.zpgl + '/file/' + row.FileName
			this.dialogImgVisible = true
		},
		LoadCPIInfo: function () {
			var that = this
			this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/ViewInfo', this.condition)
				.then(res => {
					if (res.data.Code === 0) {
						that.form.sec = res.data.Data.CPISec
						that.cpifile = res.data.Data.CPIFile
						that.cpifiledesc = res.data.Data.CPIFileDesc
						that.cpicstatusname = res.data.Data.CPICStatusName
						that.cpicinfo = res.data.Data.CPICInfo
						that.FileGuid = res.data.Data.CPIRemark4
						that.LoadFileList()
						that.LoadScoreType()
					} else {
						that.$message({
							message: res.data.Msg + '，' + res.data.Error,
							type: 'error'
						})
					}
				})
				.catch(err => {
					console.log(err)
					that.$message({
						message: '查询失败',
						type: 'error'
					})
				})
		},
		LoadFileList: function () {
			const loading = this.$loading({
				lock: true,
				spinner: 'el-icon-loading',
				background: 'rgba(255, 255, 255, 0.7)'
			})
			var that = this
			var args = {
				token: this.condition.token,
				guid: this.FileGuid
			}
			this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/FileListByGuid', args)
				.then(res => {
					if (res.data.Code === 0) {
						that.tableFileData = res.data.Data
					} else {
						that.$message({
							message: res.data.Msg + '，' + res.data.Error,
							type: 'error'
						})
					}
					loading.close()
				})
				.catch(err => {
					that.tableFileData = null
					console.log(err)
					that.$message({
						message: '查询失败',
						type: 'error'
					})
					loading.close()
				})
		},
		LoadScoreType: function () {
			var that = this
			this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/GetScoreTypeBySec', this.form)
				.then(res => {
					if (res.data.Code === 0) {
						that.ScoreType = res.data.Data
						that.LoadScoreStu()
					} else {
						that.$message({
							message: res.data.Msg + '，' + res.data.Error,
							type: 'error'
						})
					}
				})
				.catch(err => {
					console.log(err)
					that.$message({
						message: '查询失败',
						type: 'error'
					})
				})
		},
		LoadScoreStu: function () {
			const loading = this.$loading({
				lock: true,
				spinner: 'el-icon-loading',
				background: 'rgba(255, 255, 255, 0.7)'
			})
			var that = this
			this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/ScoreStu', this.condition)
				.then(res => {
					if (res.data.Code === 0) {
						that.form.tableData = res.data.Data
						// that.$nextTick(() => {
						//   that.$refs.scoretable.doLayout();
						// })
						that.form.tableData.forEach(function (item) {
							if (item.IsCanCheck == 1) {
								that.CheckError++
								if (item.ScoreType == 0) {
									that.CheckErrorMessage += item.CPIDName + "(" + item.CPIDNo +
										") 没有设置出科状态。"
								} else if (item.ScoreType == 1) {
									that.CheckErrorMessage += item.CPIDName + "(" + item.CPIDNo +
										") 还有评分没有完成。"
								} else if (item.ScoreType == 2) {
									that.CheckErrorMessage += item.CPIDName + "(" + item.CPIDNo +
										") 延期考核申请没有审核通过。"
								}
							}
						})
						console.log(that.CheckError > 0)
						console.log(that.CheckErrorMessage)
						that.LoadCPIRemark()
					} else {
						that.$message({
							message: res.data.Msg + '，' + res.data.Error,
							type: 'error'
						})
					}
					loading.close()
				})
				.catch(err => {
					that.form.tableData = null
					that.index = 0
					console.log(err)
					that.$message({
						message: '查询失败',
						type: 'error'
					})
					loading.close()
				})
		},
		LoadCPIRemark: function () {
			const loading = this.$loading({
				lock: true,
				spinner: 'el-icon-loading',
				background: 'rgba(255, 255, 255, 0.7)'
			})
			var that = this
			this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/GetCPIRemark', this.condition)
				.then(res => {
					if (res.data.Code === 0) {
						that.form.remarkTable = res.data.Data
					} else {
						that.$message({
							message: res.data.Msg + '，' + res.data.Error,
							type: 'error'
						})
					}
					loading.close()
				})
				.catch(err => {
					that.form.remarkTable = []
					console.log(err)
					that.$message({
						message: '查询失败',
						type: 'error'
					})
					loading.close()
				})
		},
		Check: function (state) {
			if (this.CheckError > 0) {
				this.$alert(this.CheckErrorMessage, '警告', {
					confirmButtonText: '确定'
				})
				this.fullscreenLoading = false
				return
			}

			// for (let i = 0; i < this.form.tableData.length; i++) {
			//   let stuname = this.form.tableData[i].CPIDName
			//   if (this.ScoreType == '0') {
			//     for (let j = 1; j <= 11; j++) {
			//       if (this.form.tableData[i]["CPIDContent" + j] === null || this.form.tableData[i]["CPIDContent" + j] ===
			//         '') {
			//         let contenttitle = this.content[j - 1].value
			//         let message = "学员 " + stuname + " 的 " + contenttitle + " 未填写"
			//         this.$alert(message, '警告', {
			//           confirmButtonText: '确定'
			//         })
			//         this.fullscreenLoading = false
			//         return
			//       }
			//     }
			//   } else {
			//     for (let j = 1; j <= 10; j++) {
			//       if (this.form.tableData[i]["CPIDContent" + j] === null || this.form.tableData[i]["CPIDContent" + j] ===
			//         '') {
			//         let contenttitle = ''
			//         if (this.ScoreType == '1') {
			//           contenttitle = this.content1[j - 1].value
			//         } else if (this.ScoreType == '2') {
			//           contenttitle = this.content2[j - 1].value
			//         }
			//         let message = "学员 " + stuname + " 的 " + contenttitle + " 未填写"
			//         this.$alert(message, '警告', {
			//           confirmButtonText: '确定'
			//         })
			//         this.fullscreenLoading = false
			//         return
			//       }
			//     }
			//   }
			// }

			// for (let i = 0; i < this.form.remarkTable.length; i++) {
			//   if (this.form.remarkTable[i]["ContentRemark"] === null || this.form.remarkTable[i]["ContentRemark"] ===
			//     '') {
			//     let stuname = this.form.remarkTable[i]["StuName"]
			//     let contenttitle = this.form.remarkTable[i]["ETDContent"]
			//     let message = "学员 " + stuname + " 的 " + contenttitle + " 的 优秀评分理由 未填写"
			//     this.$alert(message, '警告', {
			//       confirmButtonText: '确定'
			//     })
			//     this.fullscreenLoading = false
			//     return
			//   }
			// }

			this.form.cpicstatus = state
			var message = ""
			if (state === 1) {
				message = '确认审核通过该住培生绩效考评信息？'
			} else {
				message = '确认退回该住培生绩效考评信息？'
			}
			this.$confirm(message, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.fullscreenLoading = true
				this.$http.post(this.$utils.Url.zpgl + '/api/APICPI/Check', this.form)
					.then(res => {
						console.log(res.data)
						if (res.data.Code === 0) {
							this.$message({
								message: '审核成功',
								type: 'success'
							})
							console.log('刷新页面')
							this.$router.push('/main/achievement/stu/scorerecordchecklist')
						} else {
							this.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
						this.fullscreenLoading = false
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '提交失败',
							type: 'error'
						})
						this.fullscreenLoading = false
					})
			}).catch(() => { })
		},
		LoadErrorInfo: function () {
			let that = this
			var args = {
				id: this.$route.params.id
			}
			that.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICPI/GetNoPassStu', args, function (data) {
				console.log(data)
				if (data.Data.length > 0) {
					that.errorInfoVisible = true
					that.errorTableData = data.Data
					return
				}
			}, null, null, null)
		},
	},
	mounted: function () {
		this.form.token = sessionStorage.getItem('token')
		this.condition.token = sessionStorage.getItem('token')
		this.condition.id = this.$route.params.id
		this.form.id = this.$route.params.cid
		this.secname = this.$route.params.secname
		this.cpidate = this.$route.params.cpidate
		this.LoadCPIInfo()
		this.LoadErrorInfo()
	}
}
</script>

<style scoped="scoped">
.m-form.m-form--group-seperator-dashed .m-form__group {
	border-bottom: 0;
}

::v-deep .el-table__header-wrapper {
	width: 100%;
}
</style>

<style scoped="scoped">
@import '../../../assets/css/stuscore.css'
</style>
